import React from "react";
import AccentReadOnlyCheckbox from "../../../../../../../common/FormFields/AccentReadOnlyCheckbox";
import HeadingComponent from "../../HeadingComponent";
import { parseAuditedChildOrdinalFromHeading } from "../../../../utils/sectionDisplayOrdinal";
import {
  getRichTextCategoryDisplayValue,
  normalizeRichTextFieldForRenderHtml,
} from "../../../../utils/previewUtils";
import RenderHtml from "../../../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml";
/* Lexical table cell/header styles (.PlaygroundEditorTheme__*) — same as Document Rich Text */
import "../../../../../../../common/RichTextEditor/LexicalEditor/themes/PlaygroundEditorTheme.css";
import "../../../../../../../common/RichTextEditor/LexicalEditor/ui/ContentEditable.css";
import "../../../../../../RichText/RichText.css";

const RichText = ({
  content,
  globalCount,
  heading,
  treepath,
  showCheckbox,
  isChecked,
  onCheckboxChange,
  disabled = false,
  readOnlyCheckboxTitleMatch = null,
  /** Audit review: heading is already "Rich Text N" — omit form-style field captions */
  hideRichTextFieldLabels = false,
}) => {
  const auditBarRichTextN =
    readOnlyCheckboxTitleMatch?.kind === "richText" &&
    readOnlyCheckboxTitleMatch.n != null &&
    !Number.isNaN(Number(readOnlyCheckboxTitleMatch.n))
      ? Number(readOnlyCheckboxTitleMatch.n)
      : null;
  const displayHeading = (() => {
    if (auditBarRichTextN != null && isChecked) {
      return `Rich Text ${auditBarRichTextN}`;
    }
    if (typeof heading === "string" && /^Rich\s+Text\s+\d+/i.test(heading.trim())) {
      return heading.trim();
    }
    if (globalCount != null && !Number.isNaN(Number(globalCount))) {
      return `Rich Text ${globalCount}`;
    }
    if (typeof heading === "string" && heading.trim()) return heading.trim();
    return "Rich Text";
  })();
  const ordinalForHighlight =
    auditBarRichTextN != null && isChecked
      ? auditBarRichTextN
      : parseAuditedChildOrdinalFromHeading(heading, "richText") ??
        (globalCount != null && !Number.isNaN(Number(globalCount)) ? Number(globalCount) : null);
  const emphasizeReadOnlyCheckbox =
    disabled &&
    readOnlyCheckboxTitleMatch?.kind === "richText" &&
    ordinalForHighlight != null &&
    Number(readOnlyCheckboxTitleMatch.n) === Number(ordinalForHighlight) &&
    (isChecked || false);
  const richTextCategoryLabel = getRichTextCategoryDisplayValue(content);
  const richtextBodyInset = hideRichTextFieldLabels ? 0 : 10;
  return (
    <div style={{ marginTop: "20px", marginBottom:"20px" }} className="header-spacing">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {showCheckbox &&
          (disabled ? (
            <AccentReadOnlyCheckbox
              readOnlyVisual
              emphasizeChecked={emphasizeReadOnlyCheckbox}
              checked={isChecked || false}
            />
          ) : (
            <input
              type="checkbox"
              checked={isChecked || false}
              onChange={onCheckboxChange}
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                flexShrink: 0,
              }}
            />
          ))}
        <div style={{ flex: 1, width: "100%", minWidth: 0 }}>
          <HeadingComponent heading={displayHeading} treepath={treepath} />
        </div>
      </div>
      <div className="audit-trail-richtext-fields" style={{ marginTop: "8px" }}>
        {content.short_description != null && content.short_description !== "" && (
          <div
            className="richtext-editor-container"
            style={{
              paddingLeft: richtextBodyInset,
              paddingBottom: 0,
              marginTop: 0,
            }}
          >
            {!hideRichTextFieldLabels ? (
              <label className="richtext-editor-label">Short Description</label>
            ) : null}
            <div className="richtext-editor-wrapper" style={{ overflowX: "auto" }}>
              <div
                className="rich-text-content-display"
             
              >
                <RenderHtml
                  content={normalizeRichTextFieldForRenderHtml(
                    content.short_description,
                  )}
                />
              </div>
            </div>
          </div>
        )}
        {richTextCategoryLabel ? (
          hideRichTextFieldLabels ? (
            <div style={{ marginTop: "5px" }}>{richTextCategoryLabel}</div>
          ) : (
            <div
              style={{
                marginLeft: "10px",
                marginTop: "12px",
                fontSize: "14px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Rich Text Category </span>
              {richTextCategoryLabel}
            </div>
          )
        ) : null}
        {content.rich_text_content ? (
          <div
            className="richtext-editor-container"
            style={{
              paddingLeft: richtextBodyInset,
              paddingBottom: 0,
              marginTop: hideRichTextFieldLabels
                ? "5px"
                : content.short_description != null && content.short_description !== ""
                  ? "16px"
                  : 0,
            }}
          >
            {!hideRichTextFieldLabels ? (
              <label className="richtext-editor-label">Rich text content</label>
            ) : null}
            <div className="richtext-editor-wrapper" style={{ overflowX: "auto" }}>
              <div
                className="rich-text-content-display"
                style={{
                  fontSize: "14px",
                  minWidth: 0,
                }}
              >
                <RenderHtml
                  content={normalizeRichTextFieldForRenderHtml(
                    content.rich_text_content,
                  )}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default RichText;
